import React, { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Contact.css";

const SalesForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
    city: "",
    state: "",
    country: "",
    postalCode: "",
    requirement: "",
    consent: false,
  });
  const [loading, setLoading] = useState(false); // Loader state

  // const handleInputChange = (e) => {
  //   const { name, value, type, checked } = e.target;
  //   setFormData((prevData) => ({
  //     ...prevData,
  //     [name]: type === "checkbox" ? checked : value,
  //   }));
  // };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
  
    // Allow only numeric values for "phone" field
    if (name === "phone") {
      const numericValue = value.replace(/[^0-9]/g, ""); // Remove non-numeric characters
      setFormData({
        ...formData,
        [name]: numericValue,
      });
    } else {
      setFormData({
        ...formData,
        [name]: type === "checkbox" ? checked : value,
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); // Show loader on form submit

    try {
      const response = await fetch("https://dasmesh-mailer.ritaz.in/sales-send-email", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        // alert("Email sent successfully!");
        toast.success("Email sent successfully!"); // Success toast
        setFormData({}); // Reset form data
        resetForm(); // Call reset function after success
      } else {
        // alert("Error sending email!");
        toast.error("Error sending email!"); // Error toast
      }
    } catch (error) {
      //   alert("Error sending email!");
      toast.error("Error sending email!"); // Error toast
    } finally {
      setLoading(false); // Hide loader after submission
    }
  };

  const defaultFormData = {
    name: "",
    email: "",
    phone: "",
    address: "",
    city: "",
    state: "",
    country: "",
    postalCode: "",
    requirement: "",
    consent: false,
  };

  // Reset form function
  const resetForm = () => {
    setFormData(defaultFormData); // Reset all fields to their initial state
  };

  return (
    <>
      <div className="contact-form-contact">
        <div className="export-contact-form">
          <h3>SALES ENQUIRY</h3>
          <p id="conetct-p-tag-top-form">
            Fill in the form below or send your requirement directly on{" "}
            <span>sales@dasmesh.com</span> and we will provide you the best
            quote as soon as possible
          </p>
          <div className="form-container">
            <form onSubmit={handleSubmit}>
              <div className="form-row">
                <div className="form-group">
                  <input
                    type="text"
                    id="name"
                    name="name"
                    placeholder="Your Name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <input
                    type="email"
                    id="email"
                    name="email"
                    placeholder="Email Address"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <input
                    type="text"
                    id="phone"
                    name="phone"
                    placeholder="Phone No."
                    value={formData.phone}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <input
                    type="text"
                    id="address"
                    name="address"
                    placeholder="Local Address"
                    value={formData.address}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <input
                    type="text"
                    id="city"
                    name="city"
                    placeholder="City"
                    value={formData.city}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <input
                    type="text"
                    id="state"
                    name="state"
                    placeholder="State/Province"
                    value={formData.state}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <input
                    type="text"
                    id="country"
                    name="country"
                    placeholder="Country"
                    value={formData.country}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <input
                    type="text"
                    id="postalCode"
                    name="postalCode"
                    placeholder="Postal Code"
                    value={formData.postalCode}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </div>

              <div className="form-group">
                <textarea
                  id="requirement"
                  name="requirement"
                  placeholder="Describe Your Requirement"
                  value={formData.requirement}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="contact-checkbox-form">
                <input
                  type="checkbox"
                  id="consent"
                  name="consent"
                  checked={formData.consent}
                  onChange={handleInputChange}
                  required
                />
                <p>
                  By checking this box, you consent and agree to DASMESH sending
                  text messages or placing voice calls (live or pre-recorded),
                  to the telephone number you have provided, for advertising and
                  telemarketing purposes. You understand that you are not
                  required to sign or enter into this agreement as a condition
                  of purchasing any property, goods, or services. You further
                  accept our privacy policy and Legal Disclaimer. *
                </p>
              </div>

              {/* <span> <input type="submit" name="submit" value="Send" /> </span> */}
              <button type="submit" disabled={loading}>
                {loading ? "Sending..." : "Send Email"}
              </button>
            </form>
            {/* Toast container */}
            <ToastContainer
              position="top-right"
              autoClose={3000}
              hideProgressBar={false}
              closeOnClick
              pauseOnHover
              draggable
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default SalesForm;
